Alpine.data(
    "itemPriceCalculator",
    ({
        cost,
        tax,
        waste_factor,
        delivery_cost,
        new_construction_markup = 43.37,
        renovation_markup = 67.36,
    } = {}) => ({
        tax,
        cost,
        waste_factor,
        delivery_cost,
        newConstructionMarkup: new_construction_markup,
        renovationMarkup: renovation_markup,
        _calculateDisplayPrice(markupPercent) {
            const cost = Number(this.cost) || 0;
            const tax = (Number(this.tax) || 0) / 100;
            const wasteFactor = (Number(this.waste_factor) || 0) / 100;
            const deliveryCost = Number(this.delivery_cost) || 0;
            const markup = markupPercent / 100;

            const unitPrice = cost * (1 + markup);
            const priceWithWaste = unitPrice * (1 + wasteFactor);
            const taxAmount = priceWithWaste * tax;

            return parseFloat(
                priceWithWaste + taxAmount + deliveryCost,
            ).toFixed(2);
        },
        _calculateMargin(markupPercent) {
            const markup = markupPercent / 100;
            return ((markup / (1 + markup)) * 100).toFixed(2);
        },
        get newConstructionPrice() {
            return this._calculateDisplayPrice(this.newConstructionMarkup);
        },
        get renovationPrice() {
            return this._calculateDisplayPrice(this.renovationMarkup);
        },
        get newConstructionMargin() {
            return this._calculateMargin(this.newConstructionMarkup);
        },
        get renovationMargin() {
            return this._calculateMargin(this.renovationMarkup);
        },
    }),
);
